import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  LinearProgress,
  TableContainer,
  TableHeader,
} from '@occc-app/design-system';
import { TransactionStateChangeFragment } from '@occc/graphql';
import { sentenceCase } from '@occc-app/lib/strings';

import { detailsPage as copy } from './transaction-details.copies';
import { getDateCell } from './transaction-details.utils';

type TransactionStateChangesProps = {
  stateChanges: (TransactionStateChangeFragment | null)[];
  loading?: boolean;
};

export const TransactionStateChanges = ({
  stateChanges,
  loading,
}: TransactionStateChangesProps) => (
  <TableContainer
    sx={(theme) => ({
      marginBottom: theme.spacing(1),
    })}
  >
    <TableHeader title={copy.eventLogSection.title} />
    {loading && <LinearProgress />}
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Time</TableCell>
          <TableCell>Primary Status</TableCell>
          <TableCell>Secondary Status</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {stateChanges.map((item, index) => (
          <TableRow key={index}>
            <TableCell>{getDateCell(item, index, stateChanges)}</TableCell>
            <TableCell>{sentenceCase(item?.primaryStatus)}</TableCell>
            <TableCell>{sentenceCase(item?.secondaryStatus)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);
